<lib-gung-accordion>
  @for (group of groupedProductDetails; track group.groupId) {
    <lib-gung-accordion-item [collapsed]="group.collapsed" [id]="group.groupId">
      <ng-template libGungAccordionHeader><span translate>{{ group.groupName || 'PRODUCT_DETAILS' }}</span></ng-template>
      <ng-template libGungAccordionBody>
        <div class="{{divClass}}">
          <table class="table {{tableClass}}" [class.attribute-table]="!removeAttributeTable">
            <tbody>
              <tr *ngFor="let item of group.items">
                <ng-container *ngIf="!!item.value || showEmpty">
                  <th *ngIf="!item.hideFieldName">
                    {{ item.title | uppercase | translate }}
                  </th>
                  <td [attr.colspan]="item.hideFieldName ? 2 : null">
                    <ng-container [ngSwitch]="item.type">
                      <!-- Link -->
                      <a *ngSwitchCase="'link'" target="_blank" [href]="item.url || item.value">{{ item.value | translate }}</a>

                      <!-- Symbol -->
                      <div *ngSwitchCase="'symbol'" class="symbols">
                        @for(symbol of item.value; track symbol.symbol) {
                          @if (symbol?.symbol?.startsWith('http')) {
                            <img [src]="symbol.symbol" [alt]="symbol.description" height="60px" width="auto"/>
                          }
                        }
                      </div>

                      <!-- Text/HTML -->
                      <span *ngSwitchDefault class="copy-wrapper" [ngClass]="{ 'break-spaces': item.type === 'textarea' }" [innerHTML]="(item.value | translate)| safeHtml"></span>
                    </ng-container>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </lib-gung-accordion-item>
  }
</lib-gung-accordion>
